export const MAPPING_SOURCE_CONFIRM_CODE = 'MAPPING_SOURCE_REQUIRES_CONFIRMATION';

export type MappingRegenConfirmInfo = {
    estimatedCredits: number;
    creditsRemaining?: number;
};

export type InsufficientCreditsInfo = {
    creditsRequired: number;
    creditsAvailable: number;
    deficit: number;
    plan?: string;
};

export function parseMappingRegenConflict(data: {
    status?: number;
    body?: any;
}): MappingRegenConfirmInfo | null {
    const statusCode = data.body?.status_code ?? data.status;
    const code = data.body?.data?.code || data.body?.code;
    if (statusCode === 409 && code === MAPPING_SOURCE_CONFIRM_CODE) {
        return {
            estimatedCredits: Number(data.body?.data?.estimated_credits || 5),
            creditsRemaining: data.body?.data?.credits_remaining,
        };
    }
    return null;
}

export function parseInsufficientCredits(data: {
    status?: number;
    body?: any;
}): InsufficientCreditsInfo | null {
    const statusCode = data.body?.status_code ?? data.status;
    const rt = String(data.body?.response_type || '');
    const payload = data.body?.data;
    if (
        statusCode === 403 &&
        (rt.toLowerCase().includes('insufficient') || payload?.credits_required != null)
    ) {
        const required = Number(payload?.credits_required || 5);
        const available = Number(payload?.credits_available ?? payload?.credits_remaining ?? 0);
        return {
            creditsRequired: required,
            creditsAvailable: available,
            deficit: Number(payload?.deficit ?? Math.max(0, required - available)),
            plan: payload?.plan,
        };
    }
    return null;
}
